<template>
  <div class="m-box-model p-user-info">
    <CommonHeader>
      {{ $t('profile.info') }}
      <template slot="right">
        <CircleLoading v-if="loading" />
        <a
          v-else
          :class="{ disabled }"
          class="submit-btn"
          @click.prevent="handleOk"
        >
          {{ $t('complete') }}
        </a>
      </template>
    </CommonHeader>

    <main>
      <form>
        <FormAvatarItem
          v-model="avatar"
          :label="$t('profile.label.avatar')"
          type="storage"
        />

        <FormReadItem
          v-model="name"
          :label="$t('profile.label.username')"
        />

        <FormSelectItem
          v-model="sexMap[sex]"
          :label="$t('profile.label.sex')"
          @click="switchSex"
        />

        <FormInputItem
          v-model="zipcode"
          :label="$t('profile.label.zipcode')"
        />

        <FormReadItem
          v-model="location"
          :label="$t('profile.label.city')"
        />

        <FormSelectItem
          v-model="langMap[lang]"
          :label="$t('profile.label.lang')"
          @click="switchLang"
        />

        <FormTagsItem
          v-model="tags"
          :label="$t('profile.label.tag')"
          @select="onTagSelect"
          @delete="onTagRemove"
        />

        <FormInputItem
          v-model="bio"
          :maxlength="50"
          :warnlength="40"
          type="textarea"
          :label="$t('profile.label.bio')"
          :placeholder="$t('profile.placeholder.bio')"
        />
      </form>
    </main>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ARR_CONST from '../constants/app'

  export default {
    name: 'UserInfo',
    data () {
      return {
        loading: false,
        scrollHeight: 0,
        showCleanName: false,

        sexMap: this.$t('profile.sex'),
        sex: 0,
        bio: '',
        name: '',
        tags: [],
        zipcode: '',
        lang: '',
        langMap: ARR_CONST.ARR_LANG,
        // location: { label: this.$t('profile.placeholder.location') },
        location: '',
        avatar: {},
        avatarNode: '',
        change: false,

        showPosition: false,
      }
    },
    computed: {
      ...mapState(['CURRENTUSER']),
      disabled () {
        // if (!this.bio || !this.name) return true
        if (this.location.label !== this.CURRENTUSER.location) return false
        return !['sex', 'bio', 'name', 'avatar', 'zipcode', 'lang', this.change].some(
          key =>
            typeof key === 'string'
              ? this.$data[key] !== this.CURRENTUSER[key]
              : key,
        )
      },
      sexTxt () {
        return this.sexMap[this.sex] || this.$t('profile.placeholder.sex')
      },
      langTxt () {
        return this.langMap[this.lang] || ARR_CONST.ARR_LANG
      },
    },
    created () {
      this.fetchUser()
    },
    methods: {
      fetchUser () {
        const {
          sex = 0,
          bio = '',
          location = '',
          avatar = '',
          tags = [],
          zipcode = '',
          lang = '',
          name = '',
        } = this.CURRENTUSER
        this.name = name
        this.sex = sex
        this.bio = bio || ''
        this.tags = tags || []
        this.zipcode = zipcode || ''
        this.lang = lang || ''
        this.avatar = avatar
        // this.location.label = location || ''
        this.location = location || ''
        this.$http
          .get(`users/${this.CURRENTUSER.id}/tags`)
          .then(({ data = [] }) => {
            this.tags = data
            this.CURRENTUSER.tags = data
            this.$store.commit('SAVE_CURRENTUSER', this.CURRENTUSER)
          })
      },
      handleOk () {
        if (this.disabled) return
        if (this.loading) return
        this.change = false
        this.loading = true

        const param = {
          name: this.name,
          bio: this.bio,
          sex: this.sex,
          zipcode: this.zipcode,
          lang: this.lang,
          // location: this.location.label,
          location: this.location,
        }
        if (typeof this.avatar === 'string') param.avatar = this.avatar
        this.$http
          .patch('/user', param, { validateStatus: s => s === 204 })
          .then(() => {
            this.$store.commit(
              'SAVE_CURRENTUSER',
              Object.assign(this.CURRENTUSER, param),
            )
            // update the language if change
            if (this.CURRENTUSER.lang === '' || this.CURRENTUSER.lang === undefined) {
              // do nothing
            } else {
              this.$lstore.setData('I18N_LOCALE', this.CURRENTUSER.lang)
              this.$i18n.locale = this.CURRENTUSER.lang
            }
            // location.reload()

            this.goBack()
          })
          .catch(err => err)
          .finally(() => {
            this.loading = false
          })
      },
      onTagSelect (tagId) {
        this.$http.put(`/user/tags/${tagId}`)
      },
      onTagRemove (tagId) {
        this.$http.delete(`/user/tags/${tagId}`)
      },
      switchPosition (val) {
        this.showPosition = !this.showPosition
        val && (this.location = val.label)
      },
      switchSex () {
        const options = [
          { text: this.$t('profile.sex[1]'), method: () => void (this.sex = 1) },
          { text: this.$t('profile.sex[2]'), method: () => void (this.sex = 2) },
          { text: this.$t('profile.sex[0]'), method: () => void (this.sex = 0) },
        ]
        this.$bus.$emit('actionSheet', options)
      },
      switchLang () {
        const options = []
        const arrLang = ARR_CONST.ARR_LANG
        for (const property in ARR_CONST.ARR_LANG) {
          options.push({ text: arrLang[property], method: () => void (this.lang = property) })
        }
        this.$bus.$emit('actionSheet', options)
      },
    },
  }
</script>

<style lang="less" scoped>
.p-user-info {
  .submit-btn {
    color: @primary;

    &.disabled {
      color: @gray;
    }
  }

  main {
    background-color: #fff;
  }

  .m-entry-append {
    margin-right: 20px;
  }
}

.p-info-row {
  position: relative;
  padding: 35px 0 35px 0;
  margin-left: 140px;
  min-height: 100px;
  .input {
    font-size: 30px;
    line-height: 1;
  }
  label {
    display: flex;
    align-items: center;
    margin-left: -110px;
    width: 110px;
    font-size: 30px;
    line-height: inherit;
    color: @text-color3;
  }
  .m-wz-def {
    font-size: 30px;
    line-height: inherit;
    font-weight: 400;
    word-wrap: break-word;
  }
  .placeholder {
    color: #ccc;
  }
}
</style>
